// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".time-box[data-v-341177ce]{background:linear-gradient(0deg,#44ce8b,#2cb774);padding:.2rem;border-radius:10%;color:#fff}", ""]);
// Exports
module.exports = exports;
